import React from 'react';
import { Box, Typography } from '@mui/material';

import { RegionTag } from './RegionTag';

export const PersonNameCell: React.FC<{
  name: string;
  country?: string | null;
  seniority?: string | null;
  mark?: React.ReactNode;
  subtitle?: string;
  withRegion?: boolean;
}> = ({ name, country, seniority, mark, subtitle, withRegion = true }) => (
  <Box
    display="grid"
    gridTemplateColumns={withRegion ? 'auto minmax(0, 1fr)' : 'minmax(0, 1fr)'}
    alignItems="center"
    columnGap={1}
    rowGap={0.25}
  >
    {withRegion && <RegionTag country={country} />}
    <Box display="flex" alignItems="center" columnGap={1} minWidth={0}>
      <Typography variant="body1" color="text.primary" noWrap>
        {name}
      </Typography>
      {Boolean(seniority) && (
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          flexShrink={0}
        >
          {seniority}
        </Typography>
      )}
      {mark}
    </Box>
    {Boolean(subtitle) && (
      <Typography variant="body2" color="text.secondary" gridColumn={-2} noWrap>
        {subtitle}
      </Typography>
    )}
  </Box>
);
